import {Cards} from '../Card/Cards'

export const DefaultProps = {
    cardLink: {
        type: Boolean,
        default: false,
    },
    slicer: {
        type: Number,
        default: Infinity
    },
    contentType: {
        options: ['page', 'post'],
        default: 'post',
    },
    paginate: {
        type: Boolean,
        default: false,
    },
    categoryPanel: {
        type: Boolean,
        default: false,
    },
    flatCategoriesShape: {
        type: Boolean,
        default: false,
    },
    contentCategories: {
        type: Object,
        default: null
    },
    postCard: {
        options: Object.keys(Cards),
        default: 'mPostCard2'
    },
    postCardClass:{
        default:'mb-2 col-lg-4 col-md-6'
    }
}